import uniqid from 'uniqid';
import { action, createStoreEventBus } from '@twocatmoon/react-actions';
import { ReactNode } from 'react';



// #region Schema & State

const LIFE_SPAN = 2000;

export type NotificationStatus = 
  undefined | 
  'success' | 
  'warning' | 
  'error';

export interface NotificationItem {
  id: string
  message: string | ReactNode
  aliveFor: number
  status?: NotificationStatus
}

export interface NotificationsState {
  notifications: NotificationItem[]
}

const initialState = {
  notifications: []
};

// #endregion



// #region Actions

const notificationActions = {
  push: action<NotificationsState, NotificationItem>((prevState, notification) => {
    const notifications = [ ...prevState.notifications ];
    notifications.push(notification);

    return {
      notifications
    };
  }),

  splice: action<NotificationsState, number>((prevState, index) => {
    const notifications = [ ...prevState.notifications ];
    notifications.splice(index, 1);

    return {
      notifications
    };
  }),
};

// #endregion



// #region Export

const { useStore } = createStoreEventBus<NotificationsState>(initialState, notificationActions, { ssr: true });

export function useNotifications ({ lifeSpan } = { lifeSpan: LIFE_SPAN }) {
  const [ state, dispatch ] = useStore();

  const notify = (message: NotificationItem[ 'message' ], status?: NotificationStatus) => {
    dispatch(notificationActions.push({
      id: uniqid(),
      message,
      status,
      aliveFor: state.notifications.length 
        ? (lifeSpan / 2) 
        : lifeSpan
    }));
  };

  const dismiss = (index: number) => {
    dispatch(notificationActions.splice(index));
  };

  return {
    state,
    notify,
    dismiss,
  };
}

// #endregion
